<ng-container *ngIf="newsletter_show_optin">
  <ng-container *ngIf="isVisible && newsletterText">
    <div class="newsletter-checkbox-container">
      <div a11y_Checkbox class="input-checkbox-container">
        <mat-checkbox class="custom-ripple" [checked]="checked" (change)="onCheckboxChange($event.checked)">
        </mat-checkbox>
      </div>
      <div class="newsletter-checkbox-container__text" (click)="onNewsletterTextClick($event)"
        [innerHtml]="newsletterText">
      </div>
    </div>
  </ng-container>
</ng-container>